import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ExternalLink } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface ExternalLinksStatsProps {
  data: { title: string; url: string; clicks: number }[];
}

export function ExternalLinksStats({ data }: ExternalLinksStatsProps) {
  const maxClicks = Math.max(...data.map(link => link.clicks), 1);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Links Externos Mais Clicados</CardTitle>
        <CardDescription>Estatísticas de cliques em links da comunidade</CardDescription>
      </CardHeader>
      <CardContent>
        {data.length === 0 ? (
          <p className="text-sm text-muted-foreground text-center py-4">
            Nenhum link externo cadastrado
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Título</TableHead>
                <TableHead>URL</TableHead>
                <TableHead className="text-right">Cliques</TableHead>
                <TableHead>Popularidade</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((link, index) => (
                <TableRow key={index}>
                  <TableCell className="font-medium">{link.title}</TableCell>
                  <TableCell>
                    <a 
                      href={link.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-primary hover:underline flex items-center gap-1 text-sm"
                    >
                      <ExternalLink className="h-3 w-3" />
                      {new URL(link.url).hostname}
                    </a>
                  </TableCell>
                  <TableCell className="text-right">{link.clicks}</TableCell>
                  <TableCell className="w-[200px]">
                    <Progress value={(link.clicks / maxClicks) * 100} className="h-2" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
